import { ServiceMaker } from ".";

export const addVehicleType = (data:any) =>
 ServiceMaker("/vehicleType/addVehicleType", "POST",data); 

export const addVehicleSubType = (data:any) =>
 ServiceMaker("/vehicleSubType/addVehicleSubType", "POST",data);
 
 export const listvehicleType = () =>
  ServiceMaker("/vehicleType/list", "GET");
 
 export const listSullLoadVehicleSubType = () =>
  ServiceMaker("/vehicleSubType/list", "GET");